<template>
  <div>
    <hom-header></hom-header>
    <CanvasPage :terminal="4" :typeId="1"></CanvasPage>
    <!-- <div class="onlineCService">
      <div class="item borderBottom" style="cursor: pointer;" @click="onLineCS()">
        <img src="../../assets/images/keFu.png" />
        <p>在线客服</p>
      </div>
      <div class="item borderBottom weiXi">
        <img src="../../assets/images/weiXin.png" />
        <p>关注微信</p>
        <div class="cart-box-wx user-box-wx">
          <img class="wx" src="../../assets/images/gs.jpg" />
        </div>
      </div>
      <div class="item dianHa">
        <img src="../../assets/images/dianHua.png" />
        <p>电话咨询</p>
        <div class="cart-box-dh user-box-dh">
          <span class="dh">咨询电话：0539-8968590</span>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
  import CanvasPage from '@/components/canvasShow/canvasShowPage'
  import HomHeader from '@/components/base/homHeader'
  export default {
    name: 'index',
    components: { HomHeader, CanvasPage },
    data () {
      return {
        canvasData: []
      }
    },
    mounted () {
    },
    created () {
      const ttkefuico = document.getElementById('ttkefuico')
      ttkefuico.setAttribute('style', '')
      ttkefuico.setAttribute('style', 'position:fixed;_position:absolute;z-index:2147483640;left:1px;top:200px;')
      const minidialog = document.getElementById('minidialog')
      minidialog.setAttribute('style', '')
      minidialog.setAttribute('style', 'display: block; width: 300px; margin: 0px; right: 0px; bottom: 0px; position: fixed; padding: 1px; overflow: hidden; z-index: 2147483640;')
      const ttkefuminidialogtitle = document.getElementById('ttkefuminidialogtitle')
      ttkefuminidialogtitle.setAttribute('style', '')
      ttkefuminidialogtitle.setAttribute('style', 'width:300px;padding:0px; margin:0px; height:44px; line-height:35px; cursor: pointer; margin: 0 auto; font-family:Microsoft YaHei; text-indent:5px;font-size:13px;background:#6BC1FA url(https://w102.ttkefu.com/images/kf.png) no-repeat 10px center; overflow:hidden;border-top-left-radius:3px;border-top-right-radius:3px;')
      const chatdivmainwrapper = document.getElementById('chat_div_main_wrapper')
      chatdivmainwrapper.setAttribute('style', '')
      chatdivmainwrapper.setAttribute('style', 'padding:0px 1px 1px 1px; margin:0px; overflow:hidden; background:#CCCCCC;')
    },
   methods: {
      onLineCS () {
        window.open('https://w102.ttkefu.com/k/linkurl/?t=8B1BGF9', '_blank')
      }
    }
  }
</script>

<style scoped lang='scss'>
.onlineCService{
  position:fixed;
  width: 80px;
  height: 270px;
  right:0px;
  bottom: 100px;
  z-index: 9999;
  background-color: #0067ED;
  border:1px solid #0067ED;
  border-radius:2px;
  .item{
    height: 90px;
    padding-top: 15px;
    text-align: center;
    p{
      color:#fff;
      font-size: 12px;
      line-height: 25px;
    }
    .wx{
      width: 140px;
      height: 140px;
    }
    .dh{
      font-size: 15px;
      color:#0067ED;
      line-height: 60px;
    }
  }
  .weiXi{
    &:hover{
      .user-box-wx{
        display: block;
      }
    }
  }
  .dianHa{
    &:hover{
      .user-box-dh{
        display: block;
      }
    }
  }
  .borderBottom{
    border-bottom: 1px solid #fff;
  }
}
</style>
<style lang="scss" scoped>
  .cart-box-wx{
    cursor:default;
    position: absolute;
    top: 79px;
    background-color: #fff;
    z-index: 999;
    border-radius: 3px;
    box-shadow: 0px 5px 24px 3px rgba(0, 0, 0, 0.1);
    &.user-box-wx{
      height: 150px;
      width: 150px;
      top: 70px;
      left:-175px;
      display: none;
    }
  }
  .cart-box-dh{
    cursor:default;
    position: absolute;
    top: 199px;
    background-color: #fff;
    z-index: 999;
    border-radius: 3px;
    box-shadow: 0px 5px 24px 3px rgba(0, 0, 0, 0.1);
    &.user-box-dh{
      height: 60px;
      width: 250px;
      top: 190px;
      left:-275px;
      display: none;
    }
  }
  .cart-box-dh::after{
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    /* 箭头靠右边 skewY(50deg)和skewY(-50deg)可以调节箭头方向*/
    top: 25px;
    right: -20px;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 20px solid #fff;
    transform: skewY(50deg);
  }
  .cart-box-wx::after{
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    /* 箭头靠右边 skewY(50deg)和skewY(-50deg)可以调节箭头方向*/
    top: 50px;
    right: -20px;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 20px solid #fff;
    transform: skewY(50deg);
  }
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue